























import Vue from 'vue';
import layout from '@/libs/layout/school/course';
import { Component, Prop } from 'vue-property-decorator';
import { TLayout } from '@/types/utils';
import { TCourse_Page, TCourse_List } from '@/types/views/school';
@Component({
  filters: {
    typeFilter(type: any) {
      const obj = {0: 'Scratch', 1: 'Python', 2: 'C++'}
      return (obj as any)[type]
    }
  }
})
export default class Course extends Vue {
  @Prop({
    type: Object,
    default() {
      return {
        totalPage: 0,
        currentPage: 1,
        pageSize: 20,
        list: []
      };
    }
  })
  page!: TCourse_Page;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  handleOptions!: Function;
  @Prop({
    type: Function,
    default() {
      return function() {};
    }
  })
  getData!: Function;
  private layout: TLayout = layout;
  private indexMethod(idx: number) {
    const { currentPage, pageSize } = this.page;
    return ((currentPage as number) - 1) * (pageSize as number) + idx + 1;
  }
  handlePage(page: number) {
    this.handleOptions({ currentPage: page });
    this.getData();
  }
  handleSize(size: number) {
    this.handleOptions({ pageSize: size });
    this.getData();
  }
}
